import styled from 'styled-components';

const Description = styled.div`
  position: relative;
  z-index: 2;
`;

export default Description;
